/** Intelligence · horizontal — framed. Every answer resolves through the registry; an
 *  agent cannot assert a number the governance layer would refuse. Forecast: earned
 *  error bars, or an honest n/a. */
import React from 'react'
import FramedSurface from './FramedSurface'

function ForecastNa(): React.JSX.Element {
  return (
    <div className="px-8 py-8 text-center">
      <div className="text-[15px] font-semibold text-ink mb-1.5">n/a — insufficient history</div>
      <div className="text-[13px] text-mut max-w-[420px] mx-auto">
        ~5 clean Sage months is not enough to earn a forecast interval. Until it is, Intelligence says so rather than drawing a fake band.
      </div>
    </div>
  )
}

export default function Intelligence(): React.JSX.Element {
  return (
    <FramedSurface
      kicker="Intelligence · horizontal"
      kickerColor="#fbbf24"
      title="Intelligence"
      desc="Daily brief, anomaly feed, forecasts (with earned error bars or an honest n/a) and saved reports. Every answer resolves through the registry — an agent cannot assert a number the governance layer would refuse."
      chartTitle="Forecast — earned error bars, or honest n/a"
      chart={<ForecastNa />}
      notes={[
        { h: 'Daily brief', p: 'What moved, what is newly divergent, what got signed — assembled from registry events overnight.' },
        { h: 'Anomaly feed', p: 'Points that broke their own envelope; each links straight to its metric detail + drill.' },
        { h: 'Earned error bars', p: 'A forecast only shows an interval once it has enough clean history to earn one. Otherwise: honest n/a.' },
      ]}
    />
  )
}
